import React from "react";
import { ArrowRight } from "lucide-react";
import { formatPostDate } from "./posts";

export default function BlogCard({ post, locale, readMore }) {
  return (
    <a className="nfw-blog-card nfw-glass" href={`/blog/${post.slug}`}>
      <div className="nfw-blog-card-body">
        <div className="nfw-blog-meta">
          <time dateTime={post.date}>{formatPostDate(post.date, locale)}</time>
          {post.tags?.[0] && <span className="nfw-tag">{post.tags[0]}</span>}
        </div>
        <h3>{post.title}</h3>
        <p>{post.excerpt}</p>
        <span className="nfw-blog-more">
          {readMore}
          <ArrowRight size={16} />
        </span>
      </div>
    </a>
  );
}
